module.exports = __webpack_public_path__ + "img/join_03.973de6df.svg";